import { render, staticRenderFns } from "./FailureData-Column.vue?vue&type=template&id=0e5fdfa1&"
import script from "./FailureData-Column.vue?vue&type=script&lang=js&"
export * from "./FailureData-Column.vue?vue&type=script&lang=js&"
import style0 from "./FailureData-Column.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports